import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routing';
import { AuthenticationComponent } from './authentication/authentication.component';
import { AuthModule, AuthClientConfig, AuthConfig } from '@auth0/auth0-angular';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ConsultationComponent } from './consultation/consultation.component';
import { FooterModule } from './shared/footer/footer.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpBackend, HttpClient, HttpClientModule } from '@angular/common/http';
import { LoginComponent } from './login/login.component';
import { ModalModule } from './_modal';
import { NavbarModule } from './shared/navbar/navbar.module';
import { OrderConsultComponent } from './order-consult/order-consult.component';
import { ProductsComponent } from './products/products.component';
import { ReorderConsultComponent } from './reorder-consult/reorder-consult.component';
import { RouterModule } from '@angular/router';
import { SidebarModule } from './sidebar/sidebar.module';
import { WikiComponent } from './wiki/wiki.component';


function configInitializer(
  handler: HttpBackend,
  config: AuthClientConfig
) {
  return () =>{
    const http = new HttpClient(handler);
    return http
      .get('assets/config/config.json')
      .toPromise()
      .then((loadedConfig: AuthConfig) => {
        config.set(loadedConfig)
      });  
   };
}

@NgModule({
  imports: [
    BrowserAnimationsModule,
    FormsModule,
    RouterModule,
    HttpClientModule,
    NavbarModule,
    FooterModule,
    SidebarModule,
    AppRoutingModule,
    ReactiveFormsModule,
    ModalModule,
    AuthModule.forRoot()
  ],
  declarations: [
    AppComponent,
    AdminLayoutComponent,
    ProductsComponent,
    LoginComponent,
    ConsultationComponent,
    WikiComponent,
    AuthenticationComponent,
    OrderConsultComponent,
    ReorderConsultComponent],
  providers: [{
    provide: APP_INITIALIZER,
    useFactory: configInitializer,
    deps: [HttpBackend, AuthClientConfig],
    multi: true,
  }],
  bootstrap: [AppComponent]
})
export class AppModule { }